'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ColumnType = void 0;
(function (ColumnType) {
    ColumnType["FIXED"] = "FIXED";
    ColumnType["HUGGED"] = "HUGGED";
    ColumnType["STRETCHED"] = "STRETCHED";
})(exports.ColumnType || (exports.ColumnType = {}));
exports.DataType = void 0;
(function (DataType) {
    DataType["NUMBER"] = "NUMBER";
    DataType["ALPHANUMERIC"] = "ALPHANUMERIC";
    DataType["ICON"] = "ICON";
})(exports.DataType || (exports.DataType = {}));
//# sourceMappingURL=Table.types.js.map
